export default function setAuthenticatedUserData(data, store, gtag, currencyByCountry) {
  store.dispatch('setToken', data.token);
  store.dispatch('setEmail', data.email);
  store.dispatch('setUserId', data.id);
  store.dispatch('setDocType', data.doc_type);

  // GTAG event
  dataLayer.push({
    event: data.action, // 'login' o 'sign_up'
    user_id: data.id,
    email: data.email,
  });

  if (store.state.main.app) {
    // notify apps
    if (window.webkit && window.webkit.messageHandlers.authenticationEvent) {
      window.webkit.messageHandlers.authenticationEvent.postMessage({ action: 'request_notifications' });
    } else if (window.Android && window.Android.authenticationEvent) {
      window.Android.authenticationEvent(JSON.stringify({ action: 'request_notifications' }));
    }

    // if login/register from APP it's necessary to ADD USER DATA to the url
    // so the app can catch it and send it to onesignal for notifications.
    let redirectUrl = null;
    if (data.redirect_url) {
      redirectUrl = new URL(data.redirect_url);
    } else {
      redirectUrl = new URL(process.env.VUE_APP_URL);
    }
    redirectUrl.searchParams.append('user_id', data.id);
    redirectUrl.searchParams.append('full_name', data.full_name);

    window.location.href = redirectUrl;
  } else {
    window.location.href = data.redirect_url;
  }
}
